// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-03-23 15:21:17 +0100 (Mon, 23 Mar 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 161831 $
//  Purpose   : fulltext parts
// =============================================================================
import React from 'react';
import { loadLazy as ll } from 'uix/parts';
export const TreeSearchFulltext = ll(()=>import(/* webpackChunkName: 'search' */ './treesearch'));
export const SearchResult = ll(()=>import(/* webpackChunkName: 'search' */ './searchres'));
export const TreeSearchSemantic = ll(()=>import(/* webpackChunkName: 'search' */ './semsearch'));
export const IndexDetails = ll(()=>import(/* webpackChunkName: 'search' */ './indexdetails'));
export const IndexOps = ll(()=>import(/* webpackChunkName: 'search' */ './indexops'));
export const IndexFacets = ll(()=>import(/* webpackChunkName: 'search' */ './indexfacets'));
export const IndexSummary = ll(()=>import(/* webpackChunkName: 'search' */ './indexsummary'));
